import { ApiBase } from "./ApiBase";

export interface GetAgentProfileResponse {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  isAgencyManager: boolean;
  hasSetupAgency: boolean;
}

export interface AgencyAgentDto {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
}

export interface GetAgencyAgentsResponse {
  agents: AgencyAgentDto[];
}

export interface GetAgentDashboardStatsResponse {
  activeCount: number;
  rentedCount: number;
}

export interface UpdateAgencyDataRequest {
  agencyName: string;
  ejariUsername?: string;
  ejariPassword?: string;
  commissionPercentage: number;
  iban: string;
}

class AgentApi extends ApiBase {
  async getProfile() {
    return this.get<GetAgentProfileResponse>("/agent/profile");
  }

  async syncProfileFromIdentity(): Promise<void> {
    return this.post<Record<string, never>, void>("/agent/profile/sync", {});
  }

  async getDashboardStats() {
    return this.get<GetAgentDashboardStatsResponse>("/agent/dashboard/stats");
  }

  async getAgencyAgents() {
    return this.get<GetAgencyAgentsResponse>("/agency/agents");
  }

  async updateAgencyData(request: UpdateAgencyDataRequest) {
    return this.post<UpdateAgencyDataRequest, void>(
      "/agency/register",
      request,
    );
  }
}

export const agentApi = new AgentApi();
